import react from 'react';
import { useState, useEffect } from 'react';
import { Alert } from 'react-bootstrap';
import Loading from '../loadingNotification/loadingNotification';
import "./notification.css";

const Notification = (props)=>{
    return(<>
        <Alert className='notification' variant={props.type == 'success' ? 'success' : 'danger'}>
            <h3>{props.type == 'success' ? 'Sucesso!' : 'Erro!'}</h3>
            {props.message}
        </Alert>
    </>)
}

export default Notification;